import { render, staticRenderFns } from "./ModalPeerAssignee.vue?vue&type=template&id=7597c1bb&scoped=true&"
import script from "./ModalPeerAssignee.vue?vue&type=script&lang=js&"
export * from "./ModalPeerAssignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597c1bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7597c1bb')) {
      api.createRecord('7597c1bb', component.options)
    } else {
      api.reload('7597c1bb', component.options)
    }
    module.hot.accept("./ModalPeerAssignee.vue?vue&type=template&id=7597c1bb&scoped=true&", function () {
      api.rerender('7597c1bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PerAssignee/ModalPeerAssignee.vue"
export default component.exports